// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"536ef1be","453":"a94102a9","858":"3c6d90a7","921":"8121d852"}[chunkId] + ".chunk.js";
};